import React, { useEffect, useState } from 'react'
import { list } from '../api/healthcheck';
import Loader from '../components/Loader';
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function HealthCheck() {
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [healthCheckList, setHealthCheckList] = useState([])
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [selectedNews, setSelectedNews] = useState(null);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getUserHealthCheck = async () => {
        let healthCheckList = await list();

        if (healthCheckList.status >= 200 && healthCheckList.status < 400) {
            setHealthCheckList(healthCheckList.data.data)
        }
    }
    useEffect(() => {
        getUserHealthCheck();
    }, [])


    const filteredList = healthCheckList.filter(user => {
        if (!search) return true; // show all data when page loads

        return user.email?.toLowerCase().includes(search.toLowerCase());
    });



    const formateDate = (dateStr) => {
        const formatted = new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        });
        return formatted;
    }
    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="page-header">
                    <h3 className="page-title"> User Health Check List </h3>
                    {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {/* <button type="button" onClick={handleAddNews} className="btn btn-primary me-2">Add</button> */}
                        </ol>
                    </nav>
                </div>

                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="card-title mb-0">User Health Check List</h4>

                                <input
                                    type="text"
                                    className="form-control w-25"
                                    placeholder="Search by email..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Email </th>
                                            <th> Group </th>
                                            <th> Status </th>
                                            <th>HMRC Auth</th>
                                            <th>Over All</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {filteredList.map((obj, index) => {
                                            const overall = obj.cdsGroup && obj.status && obj.cds;

                                            return (
                                                <tr key={obj._id} status={obj.status}>
                                                    <td>{index + 1}</td>
                                                    <td>{obj.email}</td>
                                                    <td>{obj.cdsGroup ? "✅" : "❌"}</td>
                                                    <td>{obj.status ? "✅" : "❌"}</td>
                                                    <td>{obj.cds ? "✅" : "❌"}</td>
                                                    <td>{overall ? "✅" : "❌"}</td> {/* ✅ overall column */}
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
